import { b as d } from "./reactive-element-CzWTglSF.js";
import { render as a, noChange as c } from "../beacon-html.d/index.js";
/**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
class s extends d {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    var t, o;
    const e = super.createRenderRoot();
    return (o = (t = this.renderOptions).renderBefore) != null || (t.renderBefore = e.firstChild), e;
  }
  update(e) {
    const t = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(e), this._$Do = a(t, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    var e;
    super.connectedCallback(), (e = this._$Do) == null || e.setConnected(!0);
  }
  disconnectedCallback() {
    var e;
    super.disconnectedCallback(), (e = this._$Do) == null || e.setConnected(!1);
  }
  render() {
    return c;
  }
}
var i;
s._$litElement$ = !0, s.finalized = !0, (i = globalThis.litElementHydrateSupport) == null || i.call(globalThis, { LitElement: s });
const r = globalThis.litElementPolyfillSupport;
r == null || r({ LitElement: s });
const u = { _$AK: (n, e, t) => {
  n._$AK(e, t);
}, _$AL: (n) => n._$AL };
var l;
((l = globalThis.litElementVersions) != null ? l : globalThis.litElementVersions = []).push("4.1.1");
export {
  u as o,
  s as r
};
